import { render } from "./amount-field.vue?vue&type=template&id=35ddef18"
import script from "./amount-field.vue?vue&type=script&lang=js"
export * from "./amount-field.vue?vue&type=script&lang=js"

import "./amount-field.vue?vue&type=style&index=0&id=35ddef18&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__